import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import ProductIndex from '../views/Product/Index.vue'
import ProductEdit from '../views/Product/Edit.vue'
import ProductSort from '../views/Product/Sort.vue'
import TagIndex from '../views/Tags/Index.vue'
import ModifierCategoryIndex from '../views/ModifierCategories/Index.vue'
import ModifierIndex from '../views/Modifier/Index.vue'
import ModifierEdit from '../views/Modifier/Edit.vue'
import CategoryIndex from '../views/Category/Index.vue'
import CategoryEdit from '../views/Category/Edit.vue'
import ModifiersGroupIndex from '../views/Modificator/Index.vue'
import PromocodeEdit from '../views/Promocode/Edit.vue'
import PromocodeHome from '../views/Promocode/Home.vue'
import ComboProductEdit from '../views/ComboProduct/Edit.vue'
import ComboProductIndex from '../views/ComboProduct/Index.vue'
import SaleIndex from '../views/Sale/Index.vue'
import SaleEdit from '../views/Sale/Edit.vue'
import OrderIndex from '../views/Order/Index.vue'
import DeliveryIndex from '../views/Delivery/Index.vue'
import AreaEdit from '../views/Delivery/Area/Edit.vue'
import StreetEdit from '../views/Delivery/Street/Edit.vue'
import BranchEdit from '../views/Delivery/Branch/Edit.vue'
import WorkshopEdit from '../views/Delivery/Workshop/Edit.vue'
import UserIndex from '../views/User/Index.vue'
import UserEdit from '../views/User/Edit.vue'
import BannerEdit from '../views/Banner/Edit.vue'
import BannerIndex from '../views/Banner/Index.vue'
import NewsEdit from '../views/News/Edit.vue'
import NewsIndex from '../views/News/Index.vue'
import ArticleEdit from '../views/Articles/Edit.vue'
import ArticleIndex from '../views/Articles/Index.vue'
import JobEdit from '../views/Job/Edit.vue'
import JobIndex from '../views/Job/Index.vue'
import ContactIndex from '../views/Contact/Index.vue'
import PartnershipIndex from '../views/Partnership/Index.vue'
import PaymentDeliveryIndex from '../views/PaymentDelivery/Index.vue'
import InfoIndex from '../views/Info/Index.vue'
import ReviewIndex from '../views/Review/Index.vue'
import HomeIndex from '../views/Home/Index.vue'
import Login from '../views/Login.vue'
import TagLandingIndex from '../views/TagLanding/Index'
import TagLandingEdit from '../views/TagLanding/Edit'
import SettingIndex from '../views/Setting/Index'
import LandingPageEdit from '../views/LandingPage/Edit'
import LandingPageIndex from '../views/LandingPage/Index'
import SmsLogIndex from '../views/SmsLog/Index'
import StopsIndex from '../views/Stop/Index'
import NPSettlementEdit from '../views/Delivery/Settlement/Edit'

Vue.use(VueRouter)

const routes = [
    {
        path: '/login',
        name: 'login',
        component: Login
    },
    {
        path: '/sms-log',
        name: 'sms-log-index',
        component: SmsLogIndex
    },
    {
        path: '/stops',
        props: true,
        name: 'stops',
        component: StopsIndex
    },
    {
        path: '/product',
        name: 'product-index',
        component: ProductIndex
    },
    {
        path: '/product/create',
        props: true,
        name: 'product-create',
        component: ProductEdit
    },
    {
        path: '/product/sort',
        props: true,
        name: 'product-sort',
        component: ProductSort
    },
    {
        path: '/setting',
        props: true,
        name: 'setting-index',
        component: SettingIndex
    },
    {
        path: '/product/:id',
        props: true,
        name: 'product-edit',
        component: ProductEdit
    },
    {
        path: '/np-settlement/:id',
        props: true,
        name: 'np-settlement-edit',
        component: NPSettlementEdit
    },
    {
        path: '/home',
        name: 'home-index',
        component: HomeIndex
    },
    {
        path: '/tag-landings',
        name: 'tag-landing-index',
        component: TagLandingIndex
    },
    {
        path: '/tag-landings/:id',
        name: 'tag-landing-edit',
        props: true,
        component: TagLandingEdit
    },
    {
        path: '/landing-page/create',
        name: 'landing-page-create',
        props: true,
        component: LandingPageEdit
    },
    {
        path: '/landing-page',
        name: 'landing-page-index',
        component: LandingPageIndex
    },
    {
        path: '/landing-page/:id',
        name: 'landing-page-edit',
        props: true,
        component: LandingPageEdit
    },
    {
        path: '/tags',
        name: 'tag-index',
        component: TagIndex
    },
    {
        path: '/modifier-categories',
        name: 'modifier-category-index',
        component: ModifierCategoryIndex
    },
    {
        path: '/contact',
        name: 'contact-index',
        component: ContactIndex
    },
    {
        path: '/partnership',
        name: 'partnership-index',
        component: PartnershipIndex
    },
    {
        path: '/payment-delivery',
        name: 'payment-delivery-index',
        component: PaymentDeliveryIndex
    },
    {
        path: '/info',
        name: 'info-index',
        component: InfoIndex
    },
    {
        path: '/modifier',
        name: 'modifier-index',
        component: ModifierIndex
    },
    {
        path: '/modifier/create',
        props: true,
        name: 'modifier-create',
        component: ModifierEdit
    },
    {
        path: '/modifier/:id',
        props: true,
        name: 'modifier-edit',
        component: ModifierEdit
    },
    {
        path: '/category',
        name: 'category-index',
        component: CategoryIndex
    },
    {
        path: '/category/create',
        name: 'category-create',
        props: true,
        component: CategoryEdit
    },
    {
        path: '/category/:id/subcategory/create',
        name: 'subcategory-create',
        props: true,
        component: CategoryEdit
    },
    {
        path: '/category/:id/subcategory/:subId',
        name: 'subcategory-edit',
        props: true,
        component: CategoryEdit
    },
    {
        path: '/category/:id',
        name: 'category-edit',
        props: true,
        component: CategoryEdit
    },
    {
        path: '/modifiers-group',
        name: 'modifiers-group-index',
        component: ModifiersGroupIndex
    },
    {
        path: '/sale',
        name: 'sale-index',
        component: SaleIndex
    },
    {
        path: '/sale/create',
        name: 'sale-create',
        props: true,
        component: SaleEdit
    },
    {
        path: '/sale/:id',
        name: 'sale-edit',
        props: true,
        component: SaleEdit
    },
    {
        path: '/order',
        name: 'order-index',
        component: OrderIndex
    },
    {
        path: '/delivery',
        name: 'delivery-index',
        props: true,
        component: DeliveryIndex
    },
    {
        path: '/area/create',
        name: 'area-create',
        props: true,
        component: AreaEdit
    },
    {
        path: '/area/:id',
        name: 'area-edit',
        props: true,
        component: AreaEdit
    },
    {
        path: '/promocode',
        name: 'promocode-index',
        component: PromocodeHome
    },
    {
        path: '/promocode/create',
        name: 'promocode-create',
        props: true,
        component: PromocodeEdit
    },
    {
        path: '/promocode/:id',
        name: 'promocode-edit',
        props: true,
        component: PromocodeEdit
    },
    {
        path: '/news',
        name: 'news-index',
        component: NewsIndex
    },
    {
        path: '/news/create',
        name: 'news-create',
        props: true,
        component: NewsEdit
    },
    {
        path: '/news/:id',
        name: 'news-edit',
        props: true,
        component: NewsEdit
    },
    {
        path: '/article',
        name: 'article-index',
        component: ArticleIndex
    },
    {
        path: '/article/create',
        name: 'article-create',
        props: true,
        component: ArticleEdit
    },
    {
        path: '/article/:id',
        name: 'article-edit',
        props: true,
        component: ArticleEdit
    },
    {
        path: '/job',
        name: 'job-index',
        component: JobIndex
    },
    {
        path: '/job/create',
        name: 'job-create',
        props: true,
        component: JobEdit
    },
    {
        path: '/job/:id',
        name: 'job-edit',
        props: true,
        component: JobEdit
    },
    {
        path: '/combo-products',
        name: 'combo-product-index',
        component: ComboProductIndex
    },
    {
        path: '/combo-products/create',
        name: 'combo-product-create',
        props: true,
        component: ComboProductEdit
    },
    {
        path: '/combo-products/:id',
        name: 'combo-product-edit',
        props: true,
        component: ComboProductEdit
    },
    {
        path: '/banner',
        name: 'banner-index',
        component: BannerIndex
    },
    {
        path: '/banner/create',
        name: 'banner-create',
        props: true,
        component: BannerEdit
    },
    {
        path: '/banner/:id',
        name: 'banner-edit',
        props: true,
        component: BannerEdit
    },
    {
        path: '/review',
        name: 'review-index',
        component: ReviewIndex
    },
    {
        path: '/street/create',
        name: 'street-create',
        props: true,
        component: StreetEdit
    },
    {
        path: '/street/:id',
        name: 'street-edit',
        props: true,
        component: StreetEdit
    },
    {
        path: '/branch/create',
        name: 'branch-create',
        props: true,
        component: BranchEdit
    },
    {
        path: '/branch/:id',
        name: 'branch-edit',
        props: true,
        component: BranchEdit
    },
    {
        path: '/workshop/create',
        name: 'workshop-create',
        props: true,
        component: WorkshopEdit
    },
    {
        path: '/workshop/:id',
        name: 'workshop-edit',
        props: true,
        component: WorkshopEdit
    },
    {
        path: '/user',
        name: 'user-index',
        component: UserIndex
    },
    {
        path: '/user/:id',
        props: true,
        name: 'user-edit',
        component: UserEdit
    },
    // {
    //     path: '/modifier/:id',
    //     props: true,
    //     name: 'modifier-edit',
    //     component: ModifierEdit
    // },
]

const router = new VueRouter({
    hashbang: false,
    mode: 'history',
    routes
})

export default router
